export default __webpack_public_path__ + "static/media/c_j.390a17cd.svg";